<template>
  <div>
    <Navigation
      @login="promptLogin"
    ></Navigation>
    <router-view class="main"></router-view>
    <b-modal
      v-if="showLogin"
      v-model="showLogin"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
    >
      <template #default="props">
        <login @close="props.close"></login>
      </template>
    </b-modal>
  </div>
</template>

<script>
import Navigation from './components/Navigation';
import Login from './components/Login';

export default {
  name: 'App',
  components: {
    Login,
    Navigation,
  },
  data() {
    return {
      showLogin: false,
    };
  },
  mounted() {
    document.addEventListener('auth', this.promptLogin);
  },
  unmounted() {
    document.removeEventListener('auth', this.promptLogin);
  },
  methods: {
    promptLogin() {
      this.showLogin = true;
    },
  },
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
.main {
  margin-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue